import {
  ScreenScrapeForm,
  ScreenScrapeFormFooter,
} from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeForm';
import { Controller, useForm } from 'react-hook-form';
import ReactCodeInput from 'react-code-input';
import styled, { css } from 'styled-components';
import { ScreenScrapeButton } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeButton';
import { useSSContext } from 'src/pages/AspspSelectPage/ScreenScrape/useSSContext';
import { ScreenScrapeStepTitle } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeStepTitle';
import { media } from 'src/common/styles/breakpoints';
import { useRef, useEffect } from 'react';
import { ScreenScrapeLoader } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeLoader';
import { useCountdown } from 'src/pages/AspspSelectPage/ScreenScrape/ScreenScrapeAuthorize/useCountdown';

const StyledReactCodeInput = styled(ReactCodeInput)`
  display: flex !important;
  justify-content: center;

  input {
    border: 1px solid ${({ theme }) => theme.colors.darkGrey};
    font-size: 1.75rem;
    font-weight: 600;
    text-align: center;
    color: ${({ theme }) => theme.text.primary};
    border-radius: 0.5rem;
    width: 2.5rem;
    height: 3rem;
    transition: border 0.2s ease;

    ${media.w.min.px576(css`
      width: 3.0625rem;
      height: 3.5rem;
    `)}

    &:not(:last-child) {
      margin-right: 0.5rem;
    }

    &:focus {
      border: 1px solid ${({ theme }) => theme.colors.primary};
      outline: none;
    }
  }
`;

interface ScreenScrapeCodeFormModel {
  code: string;
}

export const ScreenScrapeCode = () => {
  const ctx = useSSContext();
  const timeoutRef = useRef<NodeJS.Timeout>();
  const { secondsRemaining, reset: resetCountdown } = useCountdown(5);

  const {
    control,
    handleSubmit,
    reset: resetForm,
    formState: { isValid, submitCount },
  } = useForm<ScreenScrapeCodeFormModel>();

  useEffect(() => {
    resetForm();
    resetCountdown();
  }, [ctx.lastJsonMessage]);

  const onSubmit = (data: ScreenScrapeCodeFormModel) => {
    // Wait at least 5s before sending another code to prevent backend auth problems
    if (submitCount > 0 && secondsRemaining > 0) {
      ctx.setIsLoading(true);
      const submitTimeout = setTimeout(() => {
        ctx.submitStep(data.code);
      }, secondsRemaining * 1000);
      timeoutRef.current = submitTimeout;
      return;
    }

    ctx.submitStep(data.code);
  };

  useEffect(() => {
    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current);
    };
  }, []);

  return ctx.isLoading ? (
    <ScreenScrapeLoader />
  ) : (
    <>
      <ScreenScrapeStepTitle>
        {ctx.lastJsonMessage?.value}
      </ScreenScrapeStepTitle>
      <ScreenScrapeForm onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="code"
          control={control}
          rules={{ required: true, minLength: 6 }}
          render={({ field }) => (
            <StyledReactCodeInput
              type="number"
              inputMode="numeric"
              fields={6}
              {...field}
            />
          )}
        />
        <ScreenScrapeFormFooter>
          <ScreenScrapeButton type="submit" disabled={!isValid}>
            Potwierdź
          </ScreenScrapeButton>
        </ScreenScrapeFormFooter>
      </ScreenScrapeForm>
    </>
  );
};
